import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { gql } from "@apollo/client";
export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  type Browser {\n    major: Int\n    name: String\n    version: Float\n  }\n\n  type OS {\n    major: Int\n    name: String\n    version: Float\n  }\n\n  type DeviceInfo @cacheControl(scope: PRIVATE, maxAge: 86400) {\n    browser: Browser\n    deviceType: String\n    deviceVendor: String\n    isAndroid: Boolean\n    isBot: Boolean\n    isChrome: Boolean\n    isChromeOS: Boolean\n    isDesktop: Boolean\n    isEdge: Boolean\n    isFirefox: Boolean\n    isIE: Boolean\n    isIOS: Boolean\n    isIPad: Boolean\n    isIPhone: Boolean\n    isMac: Boolean\n    isMobile: Boolean\n    isSafari: Boolean\n    isTablet: Boolean\n    isWindows: Boolean\n    os: OS\n    ua: String\n    isWebView: Boolean\n    isApp: Boolean\n  }\n\n  type Query {\n    deviceInfo: DeviceInfo\n  }\n"])));
export var resolvers = {
  Query: {
    deviceInfo: function () {
      var _deviceInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_parent, _args, _ref) {
        var req;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                req = _ref.req;
                return _context.abrupt("return", req.deviceInfo);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function deviceInfo(_x, _x2, _x3) {
        return _deviceInfo.apply(this, arguments);
      }

      return deviceInfo;
    }()
  }
};